export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://dev.api.headstart.health";
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://dev.headstart.health";
